import { createI18n } from 'vue-i18n'
import { messages, type SupportedLocale } from '@/locales'

const browserLocale = typeof navigator !== 'undefined'
  ? (navigator.language?.split('-')[0] as SupportedLocale | undefined)
  : undefined
const defaultLocale: SupportedLocale = browserLocale && browserLocale in messages ? browserLocale : 'en'

export const i18n = createI18n({
  legacy: false,
  locale: defaultLocale,
  fallbackLocale: 'en',
  messages,
})
